import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { Subscription } from 'rxjs';
import { CompanyService } from 'src/app/core/services/company.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { JobService } from 'src/app/core/services/job.service';
import { UserRoleService } from 'src/app/core/services/user-role.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { ResumeService } from 'src/app/core/services/resume.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { RunCandidateScore } from 'src/app/core/models/runCandidateScore';
import { FormalizeRequisition, FormalizeJobMatch, FormalizeCompany } from 'src/app/core/models/formalizePayload';
import { RequisitionService } from 'src/app/core/services/requisition.service';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import { WebSocketsService } from 'src/app/core/services/web-sockets.service';

@Component({
  selector: 'app-requisition-card',
  templateUrl: './requisition-card.component.html',
  styleUrls: ['./requisition-card.component.css']
  
})
export class RequisitionCardComponent implements OnInit, OnDestroy {

  @Input() requisitionInfo: any;
  @Input() activityMap: any;
  @Input() isRowViewActive: any;
  @Input() salaryDurationOptions: any;
  @Input() jobTypeList: any;
  @Output() deleteCallback = new EventEmitter<any>();
  @Output() copyCallback = new EventEmitter<void>();

  MESSAGECONSTANTS = MESSAGECONSTANTS;
  recentActivities: any = [];
  userNotificationControls: any = {};
  recentActivitiesControls: any = {};
  userId: any;
  contents: any = [];
  assessmentDetails: any = null;
  valueAssessmentDetails: any = null;
  endClient: any = null;
  showpopup = false;
  isRequisitionCardInfoPreAvailable = true;

  loadingFlag = true;
  isCompanyVendor = false;
  isCorporateCompany = false;
  isSuperUser = false;
  is4dot5UserAdmin = false;
  showAdditionalDetailsFlag = false;
  vendorRecruitersNotAvailable = false;
  isActivityClicked = false;
  isNotificationClicked = false;
  isRecruitersPopoverOpen = false;
  isHiringManagersPopoverOpen = false;
  jobMatchInProgress = false;
  showNotificationsFlag = false;

  numberOfNewNotifications = 0;
  notificationsSearchObject: any = {};
  companyId: any;
  options: any;
  salaryDurationOptionsLoaded: any;
  recruitersCount = 0;
  pocRecruiter: any;
  primaryHiringManager: any;
  requisitionHiringManagersDisplayMessage = '';
  requisitionRecruitersDisplayMessage = '';
  noOfDaysInRequisitionState: any;
  noOfDaysInRequisitionStateMessage: any;

  private workflowUpdateSubscription!: Subscription;

  constructor(
    private $state: StateService,
    @Inject(WebSocketsService) private webSocketsService: WebSocketsService,
    private requisitionService: RequisitionService,
    private companyService: CompanyService,
    private jobMatchService: JobMatchService,
    private jobService: JobService,
    private userRoleService: UserRoleService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private resumeService: ResumeService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.recentActivities = [];
    this.userNotificationControls = {};
    this.recentActivitiesControls = {};
    this.recentActivitiesControls.activityClickCount = 0;
    this.userNotificationControls.setNewNotificationsAsViewed = null;
    this.userNotificationControls.notificationClickCount = 0;
    this.recentActivitiesControls.getActivities = null;
    this.userId = this.authService.getUserDetails().id;
    this.contents = [];
    this.assessmentDetails = null;
    this.valueAssessmentDetails = null;
    this.endClient = null;
    this.showpopup = false;
    this.isRequisitionCardInfoPreAvailable = true;

    this.loadingFlag = true;
    this.isCompanyVendor = false;
    this.isCorporateCompany = false;
    this.showAdditionalDetailsFlag = false;
    this.vendorRecruitersNotAvailable = false;
    this.isActivityClicked = false;
    this.isNotificationClicked = false;
    this.isRecruitersPopoverOpen = false;
    this.isHiringManagersPopoverOpen = false;
    this.jobMatchInProgress = false;

    this.init(false);
  }

  private _getNoOfDaysInRequisitionState() {
    const today = new Date();
    const convertedUpdatedDate = new Date(moment(this.requisitionInfo.updatedDate).format('M/D/YYYY'));
    return Math.floor((today.getTime() - convertedUpdatedDate.getTime()) / (1000 * 3600 * 24));
  }

  private _setNoOfDaysInRequisitionState() {
    this.noOfDaysInRequisitionState = null;
    this.noOfDaysInRequisitionStateMessage = 'Number of days since Requisition updated';
    this.noOfDaysInRequisitionState = this._getNoOfDaysInRequisitionState();
  }

  init(refresh: boolean) {
    if (!refresh) {
      this._listenToRefreshCard();
      this.numberOfNewNotifications = 0;
      this.notificationsSearchObject = JSON.stringify({
        page: 1,
        size: 3,
        jobId: this.requisitionInfo.requisitionNumber,
        companyId: this.authService.getUserDetails().company.companyId,
        notifyOn: 'REQUISITION_CARD'
      });
    }
    this.showNotificationsFlag = true;
    this.showpopup = false;
    this.showAdditionalDetailsFlag = false;
    this.isRequisitionCardInfoPreAvailable = this.requisitionInfo.requisitionNumber !== undefined;
    this.options = {
      barColor: '#03a9f4',
      trackColor: '#f2f2f2',
      scaleColor: false,
      lineWidth: 8,
      size: 130,
      animate: 1500
    };
    this.companyId = this.authService.getUserDetails().company.companyId;
    this.isCompanyVendor = this.companyService.isCompanyVendor();
    this.isCorporateCompany = this.companyService.isCorporateCompany();
    this.isSuperUser = this.userRoleService.isLoggedInUserSuperUser();
    this.is4dot5UserAdmin = this.userRoleService.isLoggedInUser4dot5Admin();
    if (_.isNull(this.salaryDurationOptions) || this.salaryDurationOptions === undefined) {
      this.getSalaryDurationOptions(() => {
        if (!this.isRequisitionCardInfoPreAvailable || refresh) {
          this.getRequisitionCardInfo();
        } else {
          this._massageRequisitionCardInfo(this.requisitionInfo);
          this.loadingFlag = false;
        }
      });
    } else {
      if (!this.isRequisitionCardInfoPreAvailable || refresh) {
        this.getRequisitionCardInfo();
      } else {
        this._massageRequisitionCardInfo(this.requisitionInfo);
        this.loadingFlag = false;
      }
    }
  }

  private _listenToRefreshCard() {
    this.workflowUpdateSubscription = this.webSocketsService.receiveWorkflowUpdate().subscribe((stateChange: any) => {
      if (stateChange.reqId === this.requisitionInfo.requisitionNumber && stateChange.refreshJobCard) {
        if (stateChange.jobMatchInProgress) {
          this.jobMatchInProgress = true;
          this.requisitionInfo.jobMatchInProgress = true;
        }
        this.init(true);
      }
    });
  }

  getSalaryDurationOptions(successCallback: () => void) {
    this.jobService.getSalaryDurationOptions((data: any) => {
      this.salaryDurationOptions = data;
      if (successCallback) {
        successCallback();
      }
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getRequisitionCardInfo() {
    this.loadingFlag = true;
    this.jobService.getRequisitionDetails(this.requisitionInfo.requisitionNumber, this.companyId, (data: any) => {
      this._massageRequisitionCardInfo(data);
      this.loadingFlag = false;
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _setRecruitersAndHiringManagersDisplayMessage() {
    this.requisitionHiringManagersDisplayMessage = '';
    this.requisitionRecruitersDisplayMessage = '';
    if (this.requisitionInfo.hiringManagerDetails.length > 1) {
      const hiringManagersList: string[] = [];
      this.requisitionInfo.hiringManagerDetails.map((hiringManager: any, key: number) => {
        if (!hiringManager.isPrimary) {
          hiringManagersList.push(`${key > 0 ? ' ' : ''}${hiringManager.name}`);
        }
      });
      this.requisitionHiringManagersDisplayMessage = hiringManagersList.toString();
    }

    if (this.recruitersCount > 0) {
      const recruiterList: string[] = [];
      this.requisitionInfo.recruiters.map((recruiter: any, key: number) => {
        recruiterList.push(`${key > 0 ? ' ' : ''}${recruiter.name}`);
      });
      this.requisitionRecruitersDisplayMessage = recruiterList.toString();
    }
  }

  private _massageRequisitionCardInfo(data: any) {
    const massagedRequisitionInfo = this.requisitionService.massageRequisitionCardInfo(data, this.salaryDurationOptions);
    _.merge(this.requisitionInfo, massagedRequisitionInfo.data);
    this.recruitersCount = massagedRequisitionInfo.recruitersCount;
    this.pocRecruiter = massagedRequisitionInfo.pocRecruiter;
    this.primaryHiringManager = massagedRequisitionInfo.primaryHiringManager;
    this.endClient = this.requisitionInfo.endClient ? this.requisitionInfo.endClient.name : this.requisitionInfo.endClient;
    this._setRequisitionGraphInfo(this.requisitionInfo);
    this._setNoOfDaysInRequisitionState();
    this._setRecruitersAndHiringManagersDisplayMessage();
    this.jobMatchInProgress = data.jobMatchInProgress;
    this.showAdditionalDetailsFlag = true;
  }

  private _setRequisitionGraphInfo(requisitionInfo: any) {
    if (requisitionInfo.canEdit != null || typeof requisitionInfo.canEdit !== 'undefined') {
      requisitionInfo.canEdit = this._convertToBoolean(requisitionInfo.canEdit);
    }
    if (requisitionInfo.canDelete != null || typeof requisitionInfo.canDelete !== 'undefined') {
      requisitionInfo.canDelete = this._convertToBoolean(requisitionInfo.canDelete);
    }
    if (requisitionInfo.disableCompletedCandidate != null || typeof requisitionInfo.disableCompletedCandidate !== 'undefined') {
      requisitionInfo.disableCompletedCandidate = this._convertToBoolean(requisitionInfo.disableCompletedCandidate);
    }
    if (requisitionInfo.disableFilledCandidate != null || typeof requisitionInfo.disableFilledCandidate !== 'undefined') {
      requisitionInfo.disableFilledCandidate = this._convertToBoolean(requisitionInfo.disableFilledCandidate);
    }
    if (requisitionInfo.disableOpenState != null || typeof requisitionInfo.disableOpenState !== 'undefined') {
      requisitionInfo.disableOpenState = this._convertToBoolean(requisitionInfo.disableOpenState);
    }
    if (requisitionInfo.disableCancelState != null || typeof requisitionInfo.disableCancelState !== 'undefined') {
      requisitionInfo.disableCancelState = this._convertToBoolean(requisitionInfo.disableCancelState);
    }
    if (requisitionInfo.disablePausedState != null || typeof requisitionInfo.disablePausedState !== 'undefined') {
      requisitionInfo.disablePausedState = this._convertToBoolean(requisitionInfo.disablePausedState);
    }
    if (requisitionInfo.disableCompleteState != null || typeof requisitionInfo.disableCompleteState !== 'undefined') {
      requisitionInfo.disableCompleteState = this._convertToBoolean(requisitionInfo.disableCompleteState);
    }
    if (requisitionInfo.disableJoinState != null || typeof requisitionInfo.disableJoinState !== 'undefined') {
      requisitionInfo.disableJoinState = this._convertToBoolean(requisitionInfo.disableJoinState);
    }
    if (requisitionInfo.disableFilledState != null || typeof requisitionInfo.disableFilledState !== 'undefined') {
      requisitionInfo.disableFilledState = this._convertToBoolean(requisitionInfo.disableFilledState);
    }
    if (requisitionInfo.disableSourcedState != null || typeof requisitionInfo.disableSourcedState !== 'undefined') {
      requisitionInfo.disableSourcedState = this._convertToBoolean(requisitionInfo.disableSourcedState);
    }
  }

  private _convertToBoolean(value: any) {
    return value === 'true' || value === true;
  }

  redirectToJobWorkflow() {
    if (this.requisitionInfo.requisitionNumber !== undefined) {
      this.$state.go('missioncontrol.candidateJobMatchesWorkflow', {
        jobId: this.requisitionInfo.requisitionNumber,
        reqStateData: {
          reqStateData: this.noOfDaysInRequisitionState,
          reqStateMessage: this.noOfDaysInRequisitionStateMessage
        }
      });
    }
  }

  redirectToUpdateRequisition(id: any) {
    this.$state.go('missioncontrol.uploadreq', {
      jobId: id,
      jobState: this.requisitionInfo.requisitionStatus,
      workflowSteps: this.requisitionInfo.workflowSteps,
      fourDotFiveIntelligentThresholdScore: this.requisitionInfo.fourDotFiveIntelligentThresholdScore,
      vendorsDetails: this.requisitionInfo.vendorsDetails
    });
  }

  redirectToUpdateSharedReq(id: any) {
    this.$state.go('missioncontrol.editSharedReq', {
      jobId: id,
      jobState: this.requisitionInfo.requisitionStatus,
      corporateCompanyId: this.requisitionInfo.corporateId,
      buId: this.requisitionInfo.clientOrBuId,
      jobName: this.requisitionInfo.requisitionRole,
      jobType: this.requisitionInfo.jobType,
      requisitionInfo: this.requisitionInfo
    });
  }

  showAllActivityModal() {
    this.requisitionService.showAllActivities(this.requisitionInfo);
  }

  performAction(action: string) {
    if (action === 'runCandidateScore') {
      const confirmMessage = 'Are you sure you want to run the candidate score?';
      this.alertsAndNotificationsService.showConfirm('Run Candidate Score', confirmMessage, 'warning', true, () => {
        const requestObject: any = new RunCandidateScore(this.companyId, this.userId);
        requestObject.jobId = this.requisitionInfo.requisitionNumber;
        requestObject.rerunType = 'REQUISITION';
        this.resumeService.reRunResumeScore(requestObject, (data: any) => {
          this.alertsAndNotificationsService.showAlertWithCallBack('Candidate scoring in Progress', data.message, 'success', () => { });
        }, (error: any) => {
          this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
      }, () => {
        // do nothing
      });
    } else if (action === 'reRunScoringAndMatching') {
      const confirmMessage = 'Are you sure you want to Re-run Scoring & Matching?';
      this.alertsAndNotificationsService.showConfirm('Re-run Scoring & Matching', confirmMessage, 'warning', true, () => {
        const requestObject: any = new RunCandidateScore(this.companyId, this.userId);
        requestObject.jobId = this.requisitionInfo.requisitionNumber;
        requestObject.rerunType = 'REQUISITION';
        requestObject.source = 'RERUN_REMATCH';
        this.resumeService.reRunResumeScore(requestObject, (data: any) => {
          const successTitle = 'Re-run Scoring & Matching in Progress';
          this.alertsAndNotificationsService.showAlertWithCallBack(successTitle, data.message, 'success', () => { });
        }, (error: any) => {
          this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
      }, () => {
        // do nothing
      });
    } else {
      this.requisitionInfo.companyId = this.companyId;
      this.requisitionService.performAction(action, this.requisitionInfo, () => {
        this.init(true);
      });
    }
  }

  getRequisitionStateObject(stateName: string, requisitionObject: any) {
    const requisitionNumber = this.requisitionInfo.requisitionNumber;
    const requisitionActualNumber = this.requisitionInfo.requisitionActualNumber;
    const requisitionRole = this.requisitionInfo.requisitionRole;
    requisitionObject.formalizeActivityPayload = {
      candidate: null,
      requisition: new FormalizeRequisition(requisitionNumber, requisitionActualNumber, requisitionRole),
      jobMatch: new FormalizeJobMatch(this.requisitionInfo.jobMatchId, requisitionNumber, requisitionActualNumber, requisitionRole),
      company: new FormalizeCompany(
        this.companyId, this.requisitionInfo.companyName, this.requisitionInfo.clientOrBuId, this.requisitionInfo.clientName)
    };
    this.requisitionService.performRequisitionAction(stateName, requisitionObject, this.companyId,
      (req: any) => this.copyCallback.emit(req),
      () => this.deleteCallback.emit(requisitionObject),
      () => {
        this.init(true);
      });
  }

  showRecentActivities() {
    this.recentActivitiesControls.activityClickCount++;
    this.isActivityClicked = !this.isActivityClicked;
  }

  showNotifications() {
    this.userNotificationControls.notificationClickCount++;
    this.isNotificationClicked = !this.isNotificationClicked;
  }

  cardMenuToggled(event: Event, id: string) {
    // A click on a menu item bubbles here too; scrolling then would jump the page as the action modal opens.
    if ((event.target as HTMLElement).closest('.dropdown-menu')) {
      return;
    }
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element && element.getBoundingClientRect().bottom > window.innerHeight) {
        element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, 200);
  }

  ngOnDestroy() {
    this.webSocketsService.resetWorkflowUpdateListener();
    if (this.workflowUpdateSubscription) {
      this.workflowUpdateSubscription.unsubscribe();
    }
  }

}
